<p-confirmDialog appendTo="body"></p-confirmDialog>
<p-dialog [(visible)]="dialogFormVisible"
          [header]="'page.'+this.transPartKey+'.title' | translate"
          [modal]="true" [styleClass]="'p-fluid order-amendment-detail-dialog p-dialog-maximized'"
          [closeOnEscape]="true" (onShow)="showDialog()"
          (onHide)="closeDialog()"
          appendTo="body" position="top"
          [resizable]="false">
  <ng-template pTemplate="content">
<!--    <div class="header-form">-->
<!--      <ng-template ngFor let-fieldConfig [ngForOf]="formConfig[0].fields" let-fieldIndex="index">-->
<!--        <div class="column">-->
<!--          <label *ngIf="fieldConfig.field && fieldConfig.type!=FieldTypes.CHECKBOX" [for]="fieldConfig.field"-->
<!--                 [className]="fieldConfig.required===true?'field-required':''"-->
<!--                 [style]="'margin: 4px 3px 0 20px !important;'">-->
<!--            {{ fieldConfig.label ? fieldConfig.label : 'page.' + this.transPartKey + '.form.' + fieldConfig.field | translate }}-->
<!--          </label>-->
<!--          <app-cc-field-dispatcher #ccSubForm [loading]="false"-->
<!--                                   [transPartKey]="transPartKey"-->
<!--                                   [(formRecord)]="tableCurrentRequest" [fieldConfig]="fieldConfig"-->
<!--                                   (formRecordChange)="reLoadRecords()"-->
<!--                                   [style]="fieldConfig.type===FieldTypes.MULTISELECT?'margin: 2px 0 0 0 !important;'-->
<!--                                   :fieldConfig.type===FieldTypes.CHECKBOX?'margin: 3px 0 0 30px !important;':'margin: 1px 0 0 0 !important;'">-->
<!--          </app-cc-field-dispatcher>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--      <div class="column-flex">-->
<!--      </div>-->
<!--&lt;!&ndash;      <div *ngIf="isEditable()" class="column-btt">&ndash;&gt;-->
<!--&lt;!&ndash;        <button pButton type="button" (click)="reLoadRecords()"&ndash;&gt;-->
<!--&lt;!&ndash;                [label]="'common.dialog.cancel' | translate"&ndash;&gt;-->
<!--&lt;!&ndash;                class="p-button-warning p-button-sm"></button>&ndash;&gt;-->
<!--&lt;!&ndash;        <button pButton type="button" (click)="applyOrdersChange()"&ndash;&gt;-->
<!--&lt;!&ndash;                [label]="'common.dialog.apply' | translate"&ndash;&gt;-->
<!--&lt;!&ndash;                class="p-button-success p-button-sm"></button>&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--    </div>-->
    <app-order-amendment-table #ccInvoiceDetailTable
                               [transPartKey]="transPartKey"></app-order-amendment-table>

  </ng-template>
  <ng-template pTemplate="footer">
<!--    <button pButton type="button" (click)="closeDialog()"-->
<!--            [label]="'common.dialog.close' | translate"-->
<!--            class="p-button-warning p-button-sm"></button>-->
    <button *ngIf="isEditable()" pButton type="button" (click)="closeDialog()"
            [label]="'common.dialog.cancel' | translate"
            class="p-button-warning p-button-sm"></button>
    <button *ngIf="isEditable()" pButton type="button" (click)="applyOrdersChange()"
            [label]="'common.dialog.apply' | translate"
            class="p-button-success p-button-sm"></button>
  </ng-template>
</p-dialog>
